/**
 * Sunday home and Why Sunday clips (sections/sunday-e-proof.liquid).
 * Muted, looping, inline; the poster shows first. A clip plays only while at least 40% of it is on
 * screen and pauses when it leaves. On a phone (under 720px) only the clip nearest the middle of the
 * screen plays. With reduced motion nothing plays by itself: the clips get controls instead.
 */
import { calm } from '@sunday/util';

if (!window.__sdE) {
  window.__sdE = true;
  const vids = [...document.querySelectorAll('video[data-e-clip]')];
  if (calm()) {
    vids.forEach((v) => { v.controls = true; v.preload = 'metadata'; });
  } else if (vids.length && 'IntersectionObserver' in window) {
    const seen = new Map();
    const phone = matchMedia('(max-width: 719px)');
    const pick = () => {
      const on = vids.filter((v) => (seen.get(v) || 0) >= 0.4);
      let keep = on;
      if (phone.matches && on.length > 1) {
        const mid = innerHeight / 2;
        const d = (v) => { const r = v.getBoundingClientRect(); return Math.abs(r.top + r.height / 2 - mid) + Math.abs(r.left + r.width / 2 - innerWidth / 2); };
        keep = [on.reduce((a, b) => (d(a) <= d(b) ? a : b))];
      }
      vids.forEach((v) => {
        if (keep.includes(v)) { v.muted = true; if (v.paused) v.play().catch(() => {}); } else if (!v.paused) v.pause();
      });
    };
    const io = new IntersectionObserver((es) => { es.forEach((e) => seen.set(e.target, e.isIntersecting ? e.intersectionRatio : 0)); pick(); }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });
    vids.forEach((v) => io.observe(v));
    document.querySelectorAll('[data-e-clips]').forEach((row) => row.addEventListener('scroll', () => requestAnimationFrame(pick), { passive: true }));
  }
}
